export default "__VITE_ASSET__c0e76f1a__"